// src/store/actionTypes.js

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const FETCH_TRANSACTION_DATA_REQUEST = 'FETCH_TRANSACTION_DATA_REQUEST';
export const FETCH_TRANSACTION_DATA_SUCCESS = 'FETCH_TRANSACTION_DATA_SUCCESS';
export const FETCH_TRANSACTION_DATA_FAILURE = 'FETCH_TRANSACTION_DATA_FAILURE';
